import { useMediaQuery } from "@mui/material";
import { Datagrid, FunctionField, List, SimpleList, TextField } from "react-admin";
import { MobileListRow } from "features/MobileListRow";
import { EmptyList } from "server/components";
import { UserRoleChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import HistoryDialog from "./HistoryDialog";

const getNamesText = record =>
  [record?.firstName, record?.secondName, record?.lastName].filter(Boolean).join(" ") || "-";

// A user can hold more than one role (e.g. student and doctorant), so all of them are listed.
const getUserRolesText = record =>
  record?.roleNames?.map(role => UserRoleChoices.find(c => c.id === role)?.name ?? role).join(", ") || "-";

const getBalanceText = record => Number(record?.balance ?? 0).toFixed(2);

const ListDeposits = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Депозити"
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Имена", value: getNamesText(record) }]} />
              <MobileListRow fields={[{ label: "Факултетен номер", value: record?.facultyNumber || "-" }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Тип потребител", value: getUserRolesText(record) }]} />
              <MobileListRow fields={[{ label: "Сума на депозита", value: getBalanceText(record) }]} />
            </div>
          )}
          tertiaryText={() => <HistoryDialog />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="facultyNumber"
            label="Факултетен номер"
            emptyText="-"
            sortable={false}
          />
          <FunctionField
            label="Имена"
            render={getNamesText}
            sortable={false}
          />
          <FunctionField
            label="Тип потребител"
            render={getUserRolesText}
            sortable={false}
          />
          <FunctionField
            label="Сума на депозита"
            render={getBalanceText}
            sortable={false}
          />
          <HistoryDialog />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDeposits;
